export default (props, vars) => () =>
  vars?.['usestateactivetab']?.['setState']('current');
